<template>
  <div>
    <div class="search-con search-con-top">
      保单号：<Input clearable placeholder="请输入保单号" class="search-input" v-model="formValidate.pnum"/>
      保单号状态：<Select v-model="formValidate.state" style="width:200px;">
                    <Option value="">全部</Option>
                    <Option value="1">未关联</Option>
                    <Option value="2">已关联</Option>
                </Select>
      车行名：<Select v-model="formValidate.groupid" filterable style="width:200px;" placeholder="请选择车行名">
                  <Option value="">全部</Option>
                  <Option v-for="item in carServeList" :key="item.id" :value="item.id">{{item.name}}</Option>
              </Select>
      <Button @click="searchInfo()" v-if="this.$getMenuAuthority('sys:policy:list')" class="search-btn" type="primary"><Icon type="search"/>搜索</Button>
      <Button @click="showBatch()" v-if="this.$getMenuAuthority('sys:policy:save')" class="search-btn" type="primary"><Icon type="search"/>批量生成保单号</Button>
    </div>
    <Modal v-model="editModalBatchShow" @on-ok="saveBatchInfo()" scrollable title="编辑">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80" class="edit-win">
        <FormItem label="车行" prop="groupid">
          <Select v-model="formValidate.groupid" filterable style="width:380px;">
              <Option v-for="item in carServeList" :key="item.id" :value="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="前缀" prop="prefix">
          <Input v-model="formValidate.prefix" placeholder="请输入前缀" style="width: 380px" />
        </FormItem>
        <FormItem label="个数" prop="verb">
          <Input v-model="formValidate.verb" placeholder="请输入个数" style="width: 380px" />
        </FormItem>
        <FormItem label="开始金额" prop="amount1">
          <Input v-model="formValidate.amount1" placeholder="请输入开始金额" style="width: 380px" />
        </FormItem>
        <FormItem label="结束金额" prop="amount2">
          <Input v-model="formValidate.amount2" placeholder="请输入结束金额" style="width: 380px" />
        </FormItem>
        <FormItem label="年限" prop="yearlimit">
          <Input v-model="formValidate.yearlimit" placeholder="年限格式:1,2,3,4,5" style="width: 380px" />
        </FormItem>
      </Form>
    </Modal>
    
    <Modal v-model="editModalTransferShow" @on-ok="saveTransferInfo()" scrollable title="编辑">
      <Form ref="formGarageValidate" :model="formGarageValidate" :rules="ruleGarageValidate" :label-width="80" class="edit-win">
        <FormItem label="车行" prop="name">
          <Select v-model="formGarageValidate.groupid" filterable style="width:380px;">
              <Option v-for="item in carServeList" :key="item.id" :value="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
    <Table border :columns="columns1" :data="showData.list"></Table>
    <div class="page-con">
      <Page show-total :total="showData.total" :page-size="10" @on-change="chagepage" :current="showData.pageNum" show-elevator class="pull-right" />
    </div>
  </div>
</template>

<script>
import { truncate, copyFile, constants } from 'fs';
import { fail } from 'assert';
export default {
  data () {
    return {
      editModalBatchShow: false, //批量生成保单
      editModalTransferShow: false,
      transferid: '',
      formValidate: {
        groupid: '',
        prefix: '',
        verb: '',
        amount1: '',
        amount2: '',
        yearlimit: ''
      },
      ruleValidate: {
        groupid: [
          { required: true, message: '车行不能为空'}
        ],
        prefix: [
          { required: true, message: '前缀不能为空', trigger: 'blur' }
        ],
        verb: [
          { required: true, message: '个数不能为空', trigger: 'blur' }
        ],
        amount1: [
          { required: true, message: '开始金额不能为空', trigger: 'blur' }
        ],
        amount2: [
          { required: true, message: '结束金额不能为空', trigger: 'blur' }
        ],
        yearlimit: [
          { required: true, message: '年限不能为空', trigger: 'blur' }
        ]
      },
      formGarageValidate: {
        groupid: '',
        policys: [],
      },
      ruleGarageValidate: {
        groupid: [
          { required: true, message: '车行不能为空', trigger: 'blur' }
        ]
      },
      carServeList: [],
      showData: {           //列表容器
        pageNum: 1
      },
      columns1: [
        {title: '保单号',key: 'pnum'},
        {title: '保单状态', align: 'center', key: 'state',
          render: (h, params) => {
            return h('div', params.row.state==1?'未关联':'已关联')
          }
        },
        {title: '关联销售单',key: 'salenum'},
        {title: '分配车行分组',key: 'carname'},
        {title: '是否为贷款车', align: 'center', key: 'buycartype',
          render: (h, params) => {
            return h('div', params.row.buycartype==1?'贷款车':'全款车')
          }
        },
        {title: '第一受益人',key: 'name'},
        {title: '开始金额',key: 'amount1'},
        {title: '结束金额',key: 'amount2'},
        {title: '年限',key: 'yearlimit'},
        {title: '操作',key: 'action',width: 150,align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {type: 'primary',size: 'small'},
                style: {marginRight: '5px',display: this.$getMenuAuthority('sys:policy:transfer') ? 'inline-block' : 'none'},
                on: {
                  click: () => {
                    this.formGarageValidate.policys[0] = params.row.id
                    this.editModalTransferShow = true
                  }
                }
              }, '转移车行')
            ])
          }
        }
      ]
    }
  },
  activated() {
    this.getList ()
    this.getCarServeList()
  },
  mounted () {
    this.getList ()
    this.getCarServeList()
  },
  methods: {
    searchInfo() {
      this.showData.pageNum = 1
      this.getList()
    },
    chagepage (current) {
      this.formValidate.page = current
      this.getList()
    },
    getList () {   //获取列表
      this.$Loading.start()
      this.$axios.post('/policy/list',this.formValidate)
      .then(function (response) {
        if (response.data.success) {
          this.showData = response.data.data
          this.$Loading.finish()
        } else {
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
      }.bind(this))
    },
    saveTransferInfo() {
      this.$refs.formGarageValidate.validate((valid) => {
        if (valid) {
          this.$Loading.start()
          this.$axios.post('/policy/transfer',this.formGarageValidate)
          .then(function (response) {
            if (response.data.success) {
              this.getList()
              this.$Loading.finish()
            } else {
              this.$Message.error(response.data.errMsg)
              this.$Loading.error()
            }
          }.bind(this))
        }
      })
    },
    getCarServeList () {   //获取车行列表
      this.$Loading.start()
      this.$axios.get('/policy/group')
      .then(function (response) {
        if (response.data.success) {
          this.carServeList = response.data.data
          this.$Loading.finish()
        } else {
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
      }.bind(this))
    },
    showBatch() {
      this.formValidate = {
        groupid: '',
        prefix: 'XCT',
        verb: '100',
        amount1: '1',
        amount2: '9999999',
        yearlimit: '1,2,3,4,5'
      }
      this.editModalBatchShow = true
    },
    saveBatchInfo() {
      console.log(this.formValidate)
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          this.$Loading.start()
          this.$axios.post('/policy/verb',this.formValidate)
          .then(function (response) {
            if (response.data.success) {
              this.$Message.success(response.data.data)
              this.getList()
              this.$Loading.finish()
            } else {
              this.$Message.error(response.data.errMsg)
              this.$Loading.error()
            }
          }.bind(this))
        }
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/insurance/list.vue